export default __webpack_public_path__ + "static/media/A5_LANDSCAPE_COPY_FIX_DF.98dadf9e.png";